export const priceWithTax = (price: number, taxRate: number) => {
    if (!taxRate)
        throw Error('tax is undefined');
    return Math.floor(price * (1 + (taxRate / 100)));
}
